import { render, staticRenderFns } from "./AddDisclaimer.vue?vue&type=template&id=76c05030&scoped=true"
var script = {}
import style0 from "./AddDisclaimer.vue?vue&type=style&index=0&id=76c05030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c05030",
  null
  
)

export default component.exports